import { Popconfirm } from 'antd'
import styled from 'styled-components'

export const AntPopconfirm = styled(Popconfirm)`
  .ant-popover-content {
    color: ${({ theme }) => theme.color.mainText};
  }
`
